import { render, staticRenderFns } from "./cookie-settings.vue?vue&type=template&id=64646fda&"
import script from "./cookie-settings.vue?vue&type=script&lang=js&"
export * from "./cookie-settings.vue?vue&type=script&lang=js&"
import style0 from "./cookie-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports